import { NgIf, NgTemplateOutlet } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SvgComponent } from '@app/base-components';
import { PopupService } from '@app/services';
import { getUrlAndParams } from 'haba-contentful-components';
import { I18nModule, WindowRef } from 'haba-core';
import { ProductHit } from 'haba-emporix';
import { ImageComponent } from '../../shared/image/image.component';
import { ImageSizes } from '../../shared/image/image.config';

@Component({
  selector: 'app-product-card-inline',
  templateUrl: './product-card-inline.component.html',
  styleUrls: ['./product-card-inline.component.scss'],
  imports: [NgIf, NgTemplateOutlet, RouterModule, ImageComponent, SvgComponent, I18nModule],
})
export class ProductCardInlineComponent {
  @Input() product: ProductHit;
  @Input() readonly = false;
  @Input() quantity = 1;
  @Input() index: number;
  @Input() personalizationImage: string;
  @Output() addToCart = new EventEmitter<ProductHit>();

  ImageSizes = ImageSizes;
  addToCartFinished = false;

  constructor(
    private winRef: WindowRef,
    private popupService: PopupService
  ) {}

  getUrlAndParams(url: string) {
    return getUrlAndParams(this.winRef, url);
  }

  onProductLinkClick(): void {
    this.popupService.close();
  }

  onAddToCart(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.addToCart.emit(this.product);

    this.addToCartFinished = true;
  }
}
